<template>
  <div>
    <Search
      :openCollapsed="true"
      :allowCollapse="true"
      :url="executiveActivityUrl"
      :allowFields="$lang.azmoonLang.center_execute_activity_fields"
      :hiddenFields="hiddenFieldsActivity"
      :title="$lang.azmoonLang.azmoon_activity_execute"
      config="activity"
      addModalSize="xl"
      removeModalSize="xl"
      :visibleSearch="false"
      :visibleSettings="false"
      :visibleExport="false"
      :visibleFilters="false"
      :visibleViewCount="false"
      :remove_item="remove_activity"
      :allowEdit="false"
      :dynamicButtons="tabFourButtons"
      ref="activitySearch"
      :order_by="`id:asc`"
      :dataNotExist="$lang.notRecordExist"
      @getPermisson="updatePermissions"
    />
  </div>
</template>

<script>
import { isAdmin } from "@/shared/utils";

export default {
  data() {
    return {
      permissions: [],
    };
  },
  methods: {
    isAdmin,
    updatePermissions(permissions) {
      this.permissions = [...permissions];
    },
  },
};
</script>
